export default {
    checkDuplicates(data) {
        return axios.post('/file/uploadimg/check_duplications', data);
    },
  
    removeImageBackground(data) {
        return axios.post(`${window.location.origin}/file/remove-img-background`, data);
    },

    cropImage(data) {
        return axios.post(`${window.location.origin}/file/crop-to-image`, data);
    }
}
